import { BrowserRouter,Routes,Route } from "react-router-dom";
import CandidateLogin from "./component/CandidateLogin"
import Quiz from "./component/Quiz";
import ScoreCard from "./component/view/ScoreCard";
import Login from "./component/Login";
import DashboardPanel from "./component/DashboardPanel";
import ViewProfile from "./component/view/ViewProfile";
import UserPanel from "./component/UserPanel";
import CoursePanel from "./component/CoursePanel";
import QuestionPanel from "./component/QuestionPanel";
import CandidatePanel from "./component/CandidatePanel";
import PlanPanel from "./component/PlanPanel";
import AddUser from "./component/add/AddUser";
import Home from "./component/Home";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/candidate-login/:id" element={<CandidateLogin/>} />
        <Route path="/quiz" element={<Quiz/>} />
        <Route path="/score-card" element={<ScoreCard/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/dashboard" element={<DashboardPanel/>} />
        <Route path="/profile" element={<ViewProfile/>} />
        <Route path="/user" element={<UserPanel/>} />
        <Route path="/add-user" element={<AddUser/>} />
        <Route path="/candidate" element={<CandidatePanel/>} />
        <Route path="/course" element={<CoursePanel/>} />
        <Route path="/question" element={<QuestionPanel/>} />
        <Route path="/plan" element={<PlanPanel/>} />
      </Routes>
    </BrowserRouter>

    </div>
  );
}

export default App;
